// Data → External Supabase projects. Thin assembly over the shared
// Remote* components in workspace/packages/shared/components/. All the
// sdk-bridge + realtime + schema logic lives in
// workspace/packages/shared/functions/remoteData.js so editor CMS and
// gov consume the same unit.
//
// URL shape (single route, query-driven):
//   /data/external                        → list connected projects
//   /data/external?slug=aihouse           → schema (tables) for one project
//   /data/external?slug=aihouse&t=rooms   → rows of one table

export const dataExternal = {
  extends: 'AppPage',
  metadata: (el, s) => {
    const search = (typeof window !== 'undefined' && window.location?.search) || ''
    const params = new URLSearchParams(search)
    const slug = params.get('slug')
    const table = params.get('t')
    if (slug && table) return { title: `${table} · ${slug} / External data / Symbols Workspace` }
    if (slug) return { title: `${slug} / External data / Symbols Workspace` }
    return { title: 'External data / Symbols Workspace' }
  },

  onCreate: (el, s) => {
    el.call('reactToRemotePath', s.root)
    const handler = () => el.call('reactToRemotePath', s.root)
    el._extPathSync = handler
    window.addEventListener('popstate', handler)
    window.addEventListener('locationchange', handler)
  },

  onRemove: (el) => {
    if (el._extPathSync) {
      window.removeEventListener('popstate', el._extPathSync)
      window.removeEventListener('locationchange', el._extPathSync)
    }
  },

  AppSidebar: {},

  AppMain: {
    extends: 'AppMain',
    padding: '0',

    Header: {
      extends: 'PageHeader',
      LeftGroup: {
        Breadcrumbs: {
          flow: 'x',
          align: 'center',
          gap: 'Z',
          fontSize: 'A',
          color: 'title',
          Home: {
            tag: 'button',
            type: 'button',
            padding: '0',
            background: 'transparent',
            border: 'none',
            color: 'caption',
            fontSize: 'A',
            cursor: 'pointer',
            fontWeight: '600',
            text: 'External data',
            ':hover': { color: 'title' },
            onClick: (e, el) => {
              const root = el.call('findRouteRoot', el) || el.getRoot()
              if (root) el.router('/data/external', root)
            }
          },
          Sep1: {
            hide: (el) => !el.call('parseRemotePath').slug,
            color: 'caption',
            text: ' / '
          },
          Project: {
            hide: (el) => !el.call('parseRemotePath').slug,
            tag: 'button',
            type: 'button',
            padding: '0',
            background: 'transparent',
            border: 'none',
            color: 'caption',
            fontSize: 'A',
            cursor: 'pointer',
            fontWeight: '600',
            ':hover': { color: 'title' },
            text: (el, s) => {
              const { slug } = el.call('parseRemotePath')
              if (!slug) return ''
              const list = s.root?._extProjects || []
              const p = list.find((x) => x.slug === slug)
              return p?.display_name || slug
            },
            onClick: (e, el) => {
              const { slug } = el.call('parseRemotePath')
              const root = el.call('findRouteRoot', el) || el.getRoot()
              if (root && slug) {
                el.router(el.call('makeRemoteUrl', '/data/external', { slug }), root)
              }
            }
          },
          Sep2: {
            hide: (el) => !el.call('parseRemotePath').table,
            color: 'caption',
            text: ' / '
          },
          Table: {
            hide: (el) => !el.call('parseRemotePath').table,
            tag: 'span',
            color: 'title',
            fontWeight: '700',
            text: (el) => el.call('parseRemotePath').table || ''
          }
        }
      },
      RightGroup: {
        ManageBtn: {
          tag: 'button',
          type: 'button',
          padding: 'V Z',
          round: 'Y',
          background: 'transparent',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'line',
          color: 'title',
          fontSize: 'Y2',
          cursor: 'pointer',
          text: 'Manage connections',
          onClick: (e, el) => {
            const root = el.call('findRouteRoot', el) || el.getRoot()
            if (root) el.router('/admin/integrations/supabase', root)
          }
        }
      }
    },

    Body: {
      overflow: 'auto',
      padding: 'B',
      flow: 'y',
      gap: 'B',

      RemoteProjectPicker: { __remoteBasePath: '/data/external' },
      RemoteSchemaList: {},
      RemoteTableRows: {}
    }
  }
}
